import React, { useEffect, useState } from "react";
import LeftMenu from "../../../components/layout/leftMenu";
import Header from "../../../components/layout/header";
import { ToastContainer } from "react-toastify";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import AgeingReport from "./AgeingActiveReport";
import AgeingInactive from "./AgeingInactive";
export default function AgeingHomepage() {
    const [menuClick, setMenuClick] = useState(false);

    const toggleMenu = () => {
        setMenuClick(!menuClick);
    };
    const closeMenu = () => {
        setMenuClick(false);
    };

    return (
        <div className="main-wrapper">
            <div className="top-color"></div>
            <ToastContainer
                enableMultiContainer
                containerId={"D"}
                position="bottom-right"
                autoClose={1500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
            <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
            <div className="content-wrapper">
                <Header
                    Header="Ageing Report"
                    toggleMenu={toggleMenu}
                    menuClick={menuClick}
                />
                <div className="card main-card">
                    <div className="card-body">
                        <Tabs

                        >
                            <TabList>
                                <Tab>Active</Tab>
                                <Tab>InActive</Tab>
                            </TabList>
                            <TabPanel>
                                <AgeingReport />
                            </TabPanel>
                            <TabPanel>
                                <AgeingInactive />
                            </TabPanel>
                        </Tabs>
                    </div>
                </div>
            </div>
        </div>
    );
}
